import { AutoComplete, PagedResponse } from '@elotech/components';
import { AxiosPromise } from 'axios';
import { ATSLeiAto } from 'common/type';
import { FC } from 'react';

import { Label } from '../../label/Label';

export type LeiAtoSearchProps = {
  name: string;
  value: any;
  label?: string;
  error?: string;
  size?: number;
  className?: string;
  disabled?: boolean;
  onSelect: (name: string, value: ATSLeiAto) => void;
  onSearch: (search: string) => AxiosPromise<PagedResponse<ATSLeiAto>>;
};

export const LeiAtoSearch: FC<LeiAtoSearchProps> = ({
  name,
  onSelect,
  onSearch,
  label,
  value,
  error,
  className,
  disabled = false
}) => {
  const getNumeroAno = lei => `${lei.numero || ''}/${lei.ano || ''}`;

  const getIdTce = lei => `${lei.idTce ? `- ID TCE: ${lei.idTce}` : ''}`;

  const getEscopo = lei =>
    `${lei.tipoLeiEscopo?.descricao ? `- ${lei.tipoLeiEscopo.descricao}` : ''}`;

  const getLabel = lei =>
    `${getNumeroAno(lei)} ${getIdTce(lei)} ${getEscopo(lei)}`;

  return (
    <>
      <Label>{label || 'Lei/Ato'}</Label>
      <AutoComplete
        name={name}
        value={value}
        autoFocus={false}
        onSearch={onSearch}
        onSelect={onSelect}
        className={className}
        getOptionValue={lei => lei.id}
        getOptionLabel={getLabel}
        isDisabled={disabled}
      />
      {!!error && <span className="help-message">{error}</span>}
    </>
  );
};
